export default {
    showOpQuery: false,
    mainModel: {
        name: 'drilling.normalized_opmode',
        visibleName: 'Intelie Rig State Detection',
        description: 'rig_state_model_description',
        query: `
        -- Be sure that the channels below are configured in "Identification" column in "Standard Channels" page. 
        def @@mnemonics: 
        (@@channels.weight_on_bit, 
        @@channels.hole_depth, 
        @@channels.rotary_speed, 
        @@channels.rate_of_penetration, 
        @@channels.bit_depth, 
        @@channels.fluid_flow, 
        @@channels.block_position, 
        @@channels.weight_on_hook,
        @@channels.standpipe,
        @@channels.torque);
        
        def @@event:'SomeEventType':const; -- The 'SomeEventType' should be replaced by type of generated event in Rigs Data Management.
        def @@rigName:'SomeRigName':const; -- The 'SomeRigName' should be replaced by the Rig name.
        
        @@event .timestamp:adjusted_index_timestamp mnemonic!:@@mnemonics
        => @rig_state_full @@rigName, null,  @@mnemonics
        `,
        queryOp: `-- Be sure that the channels below are configured in "Identification" column in "Standard Channels" page.
def @@mnemonics: 
(@@channels.weight_on_bit, 
@@channels.hole_depth, 
@@channels.rotary_speed, 
@@channels.rate_of_penetration, 
@@channels.bit_depth, 
@@channels.fluid_flow, 
@@channels.block_position, 
@@channels.weight_on_hook,
@@channels.standpipe,
@@channels.torque);

def @@event:'SomeEventType':const; -- The 'SomeEventType' should be replaced by type of generated event in Rigs Data Management.
def @@rigName:'SomeRigName':const; -- The 'SomeRigName' should be replaced by the Rig name.

@@event .timestamp:adjusted_index_timestamp mnemonic!:@@mnemonics
=> @rig_state_full @@rigName, null,  @@mnemonics
`
    },
    legacy: {
        name: 'normalized_operation_mode',
        visibleName: 'Intelie Rig State Legacy',
        description: 'rig_state_legacy_description',
        query: `
        def @@mnemonics: 
        (@@channels.weight_on_bit, 
        @@channels.hole_depth, 
        @@channels.rotary_speed, 
        @@channels.rate_of_penetration, 
        @@channels.bit_depth, 
        @@channels.fluid_flow, 
        @@channels.block_position, 
        @@channels.weight_on_hook); 

        SomeEventType .timestamp:adjusted_index_timestamp mnemonic!:@@mnemonics 
        => expand normalized_operation_mode(adjusted_index_timestamp#, mnemonic, value#, uom, @@mnemonics!) every 15 seconds
          `,
        queryOp: `  
        def @@mnemonics: 
        (@@channels.weight_on_bit#, 
        @@channels.hole_depth#, 
        @@channels.rotary_speed#, 
        @@channels.rate_of_penetration#, 
        @@channels.bit_depth#, 
        @@channels.fluid_flow#, 
        @@channels.block_position#,
        @@channels.block_position#, 
        @@channels.weight_on_hook#); 

        SomeEventType .timestamp:adjusted_index_timestamp mnemonic!:@@mnemonics
        => expand operation_mode(adjusted_index_timestamp#, @@mnemonics!) every 15 seconds
        `
    },
    defaultIdentifiedChannels: [
        'weight_on_bit',
        'hole_depth',
        'rotary_speed',
        'rate_of_penetration',
        'bit_depth',
        'fluid_flow',
        'block_position',
        'weight_on_hook',
        'standpipe',
        'torque'
    ],
    simplfied: {
        visibleName: 'Intelie Rig State Simplified',
        description: 'rig_state_simplified_description',
        name: 'drilling.simplified'
    },
    constantsLegacy: {
        minQueuePeriod: 45000,
        maxQueuePeriod: 600000,
        pipeLength: 9.14,
        minimumFluidFlow: 0.0012618,
        maximumTimeToDetectRevertConnection: 1200000.0,
        minimumDrillStringRotarySpeed: 0.083
    },
    constantsLegacyList: [
        {
            name: 'MIN_QUEUE_PERIOD',
            label: 'Min queue period',
            value: 45000,
            unit: 'm',
            key: 'minQueuePeriod'
        },
        {
            name: 'MAX_QUEUE_PERIOD',
            label: 'Max queue period',
            value: 600000,
            unit: 'm',
            key: 'maxQueuePeriod'
        },
        {
            name: 'PIPE_LENGTH',
            label: 'Pipe length',
            value: 9.14,
            unit: 'm',
            key: 'pipeLength'
        },
        {
            name: 'MINIMUM_FLUID_FLOW',
            label: 'Minimum fluid flow',
            value: 0.0012618,
            unit: 'm³/s',
            key: 'minimumFluidFlow'
        },
        {
            name: 'MAXIMIUM_TIME_TO_DETECT_REVERT_CONNECTION',
            label: 'Maximum Time To Detect Revert Connection',
            value: 1200000,
            unit: 's',
            key: 'maximumTimeToDetectRevertConnection'
        },
        {
            name: 'MINIMUM_DRILL_STRING_ROTARY_SPEED',
            label: 'Minimum Drill String Rotary Speed',
            value: 0.083,
            unit: 'rpm',
            key: 'minimumDrillStringRotarySpeed'
        }
    ],
    constantsRigState: {
        pipeLength: 9.14,
        standLength: 3.0,
        minimumFluidFlow: 0.0012618,
        minimumRotatorySpeed: 0.083,
        minimumWeightOnBit: 0.0,
        minimumTorque: 0.0,
        minimumStandpipePressure: 500000,
        minimumRateOfPenetration: 0.002222,
        bottomDepthTolerance: 0.75,
        movementThreshold: 0.2,
        blockWeight: 250000,
        blockWeightToleranceThreshold: 0.15,
        hookLoadRatioThreshold: 0.5,
        connectionTimeout: 1200000,
        minimumOperationDuration: 10000,
        lowBitDepthThreshold: 400,
        dataPeriod: 5,
        minimumSpeed: 0.008333,
        enableSSAFiltering: false,
        hookLoadWithoutBlockWeight: false
    },
    constantsRigStateList: [
        {
            name: 'PIPE_LENGTH',
            label: 'Pipe Length',
            value: 9.14,
            unit: 'm',
            key: 'pipeLength'
        },
        {
            name: 'STANDLENGTH',
            label: 'Stand Length',
            value: 3.0,
            unit: 'pipe(s)',
            key: 'standLength'
        },
        {
            name: 'MINIMUM_FLUID_FLOW',
            label: 'Minimum Fluid Flow',
            value: 0.0012618,
            unit: 'm³/s',
            key: 'minimumFluidFlow'
        },
        {
            name: 'MINIMUM_ROTATORY_SPEED',
            label: 'Minimum Rotatory Speed',
            value: 0.083,
            unit: 'rad/s',
            key: 'minimumRotatorySpeed'
        },
        {
            name: 'MINIMUM_WEIGHT_ON_BIT',
            label: 'Minimum Weight On Bit',
            value: 0,
            unit: 'N',
            key: 'minimumWeightOnBit'
        },
        {
            name: 'MINIMUM_TORQUE',
            label: 'Minimum Torque',
            value: 0,
            unit: 'N.m',
            key: 'minimumTorque'
        },
        {
            name: 'MINIMUM_STANDPIPE_PRESSURE',
            label: 'Minimum Standpipe Pressure',
            value: 500000,
            unit: 'Pa',
            key: 'minimumStandpipePressure'
        },
        {
            name: 'MINIMUM_RATE_OF_PENETRATION',
            label: 'Minimum Rate Of Penetration',
            value: 0.002222,
            unit: 'm/s',
            key: 'minimumRateOfPenetration'
        },
        {
            name: 'BOTTOM_DEPTH_TOLERANCE',
            label: 'Bottom Depth Tolerance',
            value: 0.75,
            unit: 'm',
            key: 'bottomDepthTolerance'
        },
        {
            name: 'MOVEMENT_THRESHOLD',
            label: 'Movement Threshold',
            value: 0.2,
            unit: 'm',
            key: 'movementThreshold'
        },
        {
            name: 'TRAVELLING_BLOCK_WEIGHT',
            label: 'Travelling Block Weight',
            value: 250000,
            unit: 'N',
            key: 'blockWeight'
        },
        {
            name: 'BLOCK_WEIGHT_TOLERANCE_THRESHOLD',
            label: 'Block Weight Tolerance Threshold',
            value: 0.15,
            unit: '',
            key: 'blockWeightToleranceThreshold'
        },
        {
            name: 'HOOK_LOAD_RATIO_THRESHOLD',
            label: 'Hook Load Ratio Threshold',
            value: 0.5,
            unit: '',
            key: 'hookLoadRatioThreshold'
        },
        {
            name: 'CONNECTION_TIMEOT',
            label: 'Connection Timeout',
            value: 1200000,
            unit: 'ms',
            key: 'connectionTimeout'
        },
        {
            name: 'MINIMUM_OPERATION_DURATION',
            label: 'Minimum Operation Duration',
            value: 10000,
            unit: 'ms',
            key: 'minimumOperationDuration'
        },
        {
            name: 'LOW_BIT_DEPTH_THRESHOLD',
            label: 'Low Bit Depth Threshold',
            value: 400,
            unit: 'm',
            key: 'lowBitDepthThreshold'
        },
        {
            name: 'DATA_PERIOD',
            label: 'Data Period',
            value: 5,
            unit: 's',
            key: 'dataPeriod'
        },
        {
            name: 'MINIMUM_SPEED',
            label: 'Minimum Speed',
            value: 0.008333,
            unit: 'm/s',
            key: 'minimumSpeed'
        },
        {
            name: 'ENABLE_SSA_FILTERING',
            label: 'Enable SSA Filtering',
            value: false,
            unit: '',
            key: 'enableSSAFiltering'
        },
        {
            name: 'HOOK_LOAD_WITHOUT_BLOCK_WEIGHT',
            label: 'Hook Load Without Block Weight',
            value: false,
            unit: '',
            key: 'hookLoadWithoutBlockWeight'
        }
    ],
    __src: 'op-mode'
}
